import React, { FC } from 'react'
import { colorMatrix } from '../../libs/helpers/colors'
import styles from '../../SearchProvider.module.scss'
import { getHrefFunction, updateClientSideUrl } from '../../helpers/url'
import {
  CustomHandleUpdateSelectedFacetParams,
  FacetOptionObject,
  FacetServiceApi,
  UseReduxSearchProviderResponse,
} from '../../types'
import FacetColorComponent from './FacetColorComponent'
import useReduxSearchProvider from '../../hooks/useReduxSearchProvider'

type ColorFacetProps = {
  baseUrl: string
  nextAppRoute: string
  facetService: FacetServiceApi
  facetName: string
  facetOptions: ReadonlyArray<FacetOptionObject>
  useReduxProviderHook?: () => UseReduxSearchProviderResponse
  customHandleUpdateSelectedFacet?: (params: CustomHandleUpdateSelectedFacetParams) => void
  customClickFacetOption?: (params: CustomHandleUpdateSelectedFacetParams) => void
}

const ColorFacet: FC<ColorFacetProps> = ({
  baseUrl,
  nextAppRoute,
  facetService,
  facetName,
  facetOptions,
  useReduxProviderHook = useReduxSearchProvider,
  customHandleUpdateSelectedFacet,
  customClickFacetOption,
}) => {
  const { selectedFacets, pathParams, sharedFacetNames } = useReduxProviderHook()

  const isColorFacetSelected = facetService.getIsFacetSelected({
    selectedFacets,
    facetValue: selectedFacets?.color?.[0],
    facetName,
  })

  const resetColorFilter = () => {
    const newSelectedFacets = { ...selectedFacets, [facetName]: [], page: [''] }
    const href = getHrefFunction({
      facetsAndQueryParams: newSelectedFacets,
      pathParams,
      sharedFacetNames,
    })()
    const newUrl = `${baseUrl}${href}`

    if (Boolean(customHandleUpdateSelectedFacet)) {
      customHandleUpdateSelectedFacet?.({ newSelectedFacets, newUrl, facetName, facetValue: '' })
      return
    }

    customClickFacetOption?.({ newSelectedFacets, newUrl, facetName, facetValue: '' })
    updateClientSideUrl(newUrl, nextAppRoute)
  }

  return (
    <div className={styles.colorFacetContainer}>
      <div className={styles.colorFacetRow}>
        {colorMatrix.map((matrix, key) => (
          <div className={styles.colorFacetColumn} key={key}>
            {matrix.map((color, key2) => (
              <FacetColorComponent
                key={key2}
                baseUrl={baseUrl}
                nextAppRoute={nextAppRoute}
                facetService={facetService}
                facetName={facetName}
                facetOptions={facetOptions}
                color={color}
                isSelected={selectedFacets?.color?.[0] === color}
                useReduxProviderHook={useReduxProviderHook}
              />
            ))}
          </div>
        ))}
      </div>
      {isColorFacetSelected && (
        <button className={styles.removeColorFilterButton} onClick={resetColorFilter}>
          Remove Color Filter
        </button>
      )}
    </div>
  )
}

export default ColorFacet
